import Button from "@/components/Button";
import SafeArea from "@/components/safe-area";
import {
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
} from "@/components/ui/drawer";

import { memo } from "react";

interface Props {
	visible: boolean;
	onClose: () => void;
	onOk: () => void;
	onOkText: string;
	onCancelText: string;
	onCancel: () => void;
	title?: string | React.ReactNode;
	children?: string | React.ReactNode;
}

const ConfirmModal = memo<Props>((props) => {
	return (
		<Drawer open={props.visible} onClose={props.onClose}>
			<DrawerContent>
				<div className="mx-auto w-full">
					<DrawerHeader>
						<DrawerTitle className="text-center text-xl font-semibold">{props.title}</DrawerTitle>
						<DrawerDescription></DrawerDescription>
					</DrawerHeader>
					<div className="text-center text-sm font-semibold px-4.5 pb-4">{props.children}</div>
					<DrawerFooter className="px-6">
						<Button block onClick={props.onOk}>
							{props.onOkText}
						</Button>
						<DrawerClose asChild>
							<Button onClick={props.onCancel} type="bordered" block>
								{props.onCancelText}
							</Button>
						</DrawerClose>
						<SafeArea position="bottom" />
					</DrawerFooter>
				</div>
			</DrawerContent>
		</Drawer>
	);
});

ConfirmModal.displayName = "ConfirmModal";
export default ConfirmModal;
